import { useQuery } from 'react-query'
import axios from 'axios'
import { request } from '../../Redux/Sagas/requests/api'

const fetchData = async (postData) => {
  // const response = await axios.post('https://api.example.com/data', postData)
  const response = await request('get-email-template-tag', 'POST', { email_template_id: postData })
  return response.data?.data
}

const useGetEmailTemplateResources = (postData) => {
  const query = useQuery(['fetchTemplateResources', postData], () => fetchData(postData), {
    enabled: !!postData,
    onSuccess: (data) => {
    },
  })

  return {
    data: query.data,
    error: query.error,
    isLoading: query.isLoading,
    isSuccess: query.isSuccess,
    isError: query.isError,
  }
}

export default useGetEmailTemplateResources
